export default "__VITE_ASSET__DT08HRWS__"